import { projectMemberGuard, projectSettingsGoalGuard, projectSettingsEventGuard, projectSettingsDurationGuard } from '@/routes/guards/project'
import mobile from 'is-mobile'

const Project = () => import('@/views/project/ViewProject')
const ProjectUpdate = () => import('@/views/project/ViewProjectUpdate')
const ProjectPrivate = () => import('@/views/project/ViewProjectPrivate')
const PrivateAllContributions = () => import('&/modules/project/PrivateAllContributions')
const PrivateContribution = () => import('&/modules/project/PrivateContribution')
const PrivateAllProducts = () => import('&/modules/project/PrivateAllProducts')
const PrivateNewProduct = () => import('&/modules/project/PrivateNewProduct')
const PrivateEditProduct = () => import('&/modules/project/PrivateEditProduct')
const ProjectQrcode = () => import('@/views/project/ViewProjectQrcode')
const ProjectSettings = () => import('@/views/project/ViewProjectSettings')
const PrivateSettingsGeneral = () => import('&/modules/project/PrivateSettingsGeneral')
const PrivateSettingsGoal = () => import('&/modules/project/PrivateSettingsGoal')
const PrivateSettingsDuration = () => import('&/modules/project/PrivateSettingsDuration')
const PrivateSettingsMembers = () => import('&/modules/project/PrivateSettingsMembers')
const PrivateSettingsEvent = () => import('&/modules/project/PrivateSettingsEvent')

const routes = [
  {
    path: 'project/:projectSlug',
    name: 'Project',
    component: Project,
    props: true,
    meta: {
      layout: 'full'
    }
  },
  {
    path: 'project/:projectSlug/contributions',
    name: 'ProjectContributions',
    component: ProjectPrivate,
    props: true,
    meta: {
      requiresAuth: true
    },
    redirect: { name: 'PrivateAllContributions' },
    beforeEnter: async to => {
      try {
        await projectMemberGuard({ to })
      } catch (redirect) {
        return redirect
      }
    },
    children: [
      {
        path: '',
        name: 'PrivateAllContributions',
        component: PrivateAllContributions,
        props: true,
        meta: {
          layout: 'full'
        }
      },
      {
        path: ':contributionId',
        name: 'PrivateContribution',
        component: PrivateContribution,
        props: true,
        meta: {
          layout: 'full'
        }
      }
    ]
  },
  {
    path: 'project/:projectSlug/products',
    name: 'ProjectProducts',
    component: ProjectPrivate,
    props: true,
    redirect: { name: 'PrivateAllProducts' },
    beforeEnter: async to => {
      try {
        await projectMemberGuard({ to })
      } catch (redirect) {
        return redirect
      }
    },
    children: [
      {
        path: '',
        name: 'PrivateAllProducts',
        component: PrivateAllProducts,
        props: true,
        meta: {
          requiresAuth: true,
          layout: 'full'
        }
      },
      {
        path: 'new',
        name: 'PrivateNewProduct',
        component: PrivateNewProduct,
        props: true,
        meta: {
          requiresAuth: true,
          layout: 'full'
        }
      },
      {
        path: ':productId',
        name: 'PrivateEditProduct',
        component: PrivateEditProduct,
        props: true,
        meta: {
          requiresAuth: true,
          layout: 'full'
        }
      }
    ]
  },
  {
    path: 'project/:projectSlug/qr-codes',
    name: 'ProjectQrcode',
    component: ProjectQrcode,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'full'
    },
    beforeEnter: async to => {
      try {
        await projectMemberGuard({ to })
      } catch (redirect) {
        return redirect
      }
    }
  },
  {
    path: 'project/:projectSlug/settings',
    name: 'ProjectSettings',
    component: ProjectSettings,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'full'
    },
    redirect: !mobile() ? { name: 'PrivateSettingsGeneral' } : null,
    beforeEnter: async to => {
      try {
        await projectMemberGuard({ to })
      } catch (redirect) {
        return redirect
      }
    },
    children: [
      {
        path: 'general',
        name: 'PrivateSettingsGeneral',
        component: PrivateSettingsGeneral,
        props: true,
        meta: {
          title: 'general',
          requiresAuth: true,
          layout: 'full'
        }
      },
      {
        path: 'goal',
        name: 'PrivateSettingsGoal',
        component: PrivateSettingsGoal,
        props: true,
        meta: {
          title: 'goal',
          requiresAuth: true,
          layout: 'full'
        },
        beforeEnter: async to => {
          try {
            await projectSettingsGoalGuard({ to })
          } catch (redirect) {
            return redirect
          }
        }
      },
      {
        path: 'duration',
        name: 'PrivateSettingsDuration',
        component: PrivateSettingsDuration,
        props: true,
        meta: {
          title: 'duration',
          requiresAuth: true,
          layout: 'full'
        },
        beforeEnter: async to => {
          try {
            await projectSettingsDurationGuard({ to })
          } catch (redirect) {
            return redirect
          }
        }
      },
      {
        path: 'members',
        name: 'PrivateSettingsMembers',
        component: PrivateSettingsMembers,
        props: true,
        meta: {
          title: 'members',
          requiresAuth: true,
          layout: 'full'
        }
      },
      {
        path: 'event',
        name: 'PrivateSettingsEvent',
        component: PrivateSettingsEvent,
        props: true,
        meta: {
          title: 'event',
          requiresAuth: true,
          layout: 'full'
        },
        beforeEnter: async to => {
          try {
            await projectSettingsEventGuard({ to })
          } catch (redirect) {
            return redirect
          }
        }
      }
    ]
  },
  {
    path: 'project/:projectSlug/update/:updateId',
    name: 'ProjectUpdate',
    component: ProjectUpdate,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'full'
    },
    beforeEnter: async to => {
      try {
        await projectMemberGuard({ to })
      } catch (redirect) {
        return redirect
      }
    }
  }
]

export default routes
